<div class="a-titulo">Reporte cartera clientes - ejecutivo</div>
<div class="a-w1-column">
  <app-datatable [filterGlobal]="true" [metadataTable]="resumenMDT" [dataTable]="resumenDT" [exportData]="administrador"
    id="'RESUMEN CARTERA CLIENTE'">
    <!-- id="'RESUMEN CARTERA CLIENTE'"> -->
    <ng-template #addHeaderTop>
      <tr class="header-table">
        <th colspan="3"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
        <th colspan="2"></th>
      </tr>
    </ng-template>

  </app-datatable>


  <p-accordion>
    <p-accordionTab header="DETALLE CLIENTES - COMPORTAMIENTO">
      <div class="a-w1-column">
        <app-datatable [filterGlobal]="true" [metadataTable]="detalleMDT" [dataTable]="detalleDT"
          [customButtons]="buttonDT" [title]="'CLIENTES DELFIN'">
          <ng-template #addHeaderTop>
            <tr>
              <th colspan="4"></th>
              <th style="font-size: 10px;text-align: center;font-weight: 700;background-color: rgba(91 135 196 / 29%);"
                colspan="14">DELFIN</th>
              <th style="font-size: 10px;text-align: center;font-weight: 700;background-color: rgba(115 209 120 / 42%);"
                colspan="14">KUNAQ</th>
            </tr>
          </ng-template>

          <ng-template #addHeaderStart>
            <th></th>
          </ng-template>
          <ng-template #addBodyStart let-row="row">
            <td>
              <div style="text-align: center;">
                <p-button icon="pi pi-chart-bar" pTooltip="Editar"
                  styleClass="p-button-rounded p-button-secondary p-button-text" (onClick)="viewDetail(row)"></p-button>
              </div>
            </td>
          </ng-template>

        </app-datatable>

      </div>
    </p-accordionTab>
    <p-accordionTab header="CLIENTES NO DELFIN">

      <app-datatable [metadataTable]="metadatatableKunaq" [dataTable]="listReporteQunacNoDelfin"
        [title]="'CLIENTES KUNAQ  (datos actualizados hasta 2024/12)'" [filterGlobal]="true">
        <ng-template #addHeaderTop>
          <tr class="header-table">
            <th style="font-size: 10px;text-align: center;font-weight: 700;"
              class="header align-items-center items-header" colspan="2"> IMPORTADOR
            </th>
            <th style="font-size: 10px;text-align: center;font-weight: 700;"
              class="header align-items-center items-header" colspan="14">
              <div style="display: flex;align-items: center;gap: 20px;justify-content: center;">
                <span>CHINA</span>
                <img src="../../../../assets/iconos/china.svg" alt="" height="17px">
              </div>
            </th>
            <th style="font-size: 10px;text-align: center;font-weight: 700;"
              class="header align-items-center items-header" colspan="14">
              <div style="display: flex;align-items: center;gap: 20px;justify-content: center;">
                <span>OTROS TRAFICOS</span>
                <img src="../../../../assets/iconos/mundo.svg" alt="" height="17px">
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template #addHeaderStart>
          <th></th>
        </ng-template>
        <ng-template #addBodyStart let-row="row">
          <td>
            <div style="text-align: center;">
              <p-button icon="pi pi-chart-bar" pTooltip="Editar"
                styleClass="p-button-rounded p-button-secondary p-button-text"
                (onClick)="viewDetailNew(row)"></p-button>
            </div>
          </td>
        </ng-template>
      </app-datatable>
    </p-accordionTab>
  </p-accordion>
</div>

<footer>
  <div class="contenido-pie">
    <p></p>
  </div>
</footer>

<p-dialog header="" [(visible)]="visible" [style]="{width: '60vw',height: '93vh'}" appendTo="body" [maximizable]="true">
  <br>
  <p-toast key="toast1"></p-toast>
  <p-toast key="toast2"></p-toast>
  <div style="justify-content: center; display: flex; gap: 20px;">
    <p-button label="Guardar" (onClick)="TransClienteCartera()" severity="info"></p-button>
    <p-button label="Salir" (onClick)="salir()" severity="info"></p-button>
  </div>
  <div style="padding-top: 20px;">
    <form [formGroup]="groupPoppup" class="a-w1" style="margin: 0;">
      <div class="a-w1-row" style="justify-content: right; width: 45%;">
        <!-- <div class="a-w2">
          <span class="p-float-label">
            <p-dropdown [options]="listaTipoEnt" placeholder="‎ " optionLabel="nombre" formControlName="tipoentidad"
              optionValue="codigo" appendTo="body" [filter]="true" [readonly]="editar" filterValue="nombre"
              class="p-inputtext-sm" (onChange)="listarEnt($event)" [showClear]="true">
            </p-dropdown>
            <label for="float-label">Tipo Ent Relación</label>
          </span>
        </div>
        <div class="a-w2">
          <span class="p-float-label">
            <p-dropdown [options]="listaTodosEnt" placeholder="‎ " optionLabel="nombre" [filter]="true"
              filterBy="nombre" formControlName="entidad" optionValue="codigo" appendTo="body" [readonly]="editar"
              class="p-inputtext-sm" [showClear]="true">
            </p-dropdown>
            <label for="float-label">Entidad</label>
          </span>
        </div> -->
        <div class="a-w2">
          <p-floatLabel class="w-full md:w-56" variant="on">
            <p-select [options]="listReg" placeholder="‎ " optionLabel="name" formControlName="regimen"
              optionValue="code" appendTo="body" styleClass="w-full md:w-56">
            </p-select>
            <label for="on_label">Regimen</label>
          </p-floatLabel>
        </div>
        <div class="a-w2">
          <p-floatLabel class="w-full md:w-56" variant="on">
            <p-select [options]="ListaTrafico" placeholder="‎ " optionLabel="name" formControlName="trafico"
              optionValue="code" appendTo="body" styleClass="w-full md:w-56">
            </p-select>
            <label for="on_label">Tráfico</label>
          </p-floatLabel>
        </div>
      </div>
      <div class="a-w1-row" style="justify-content: space-between; padding-top: 20px;">
        <div class="cabeceraPickList">
          <span style="font-weight: bold;">Clientes Disponibles</span>
          <p-button icon="pi pi-file-excel" severity="success" (onClick)="ExportFormat()" styleClass="p-button-success"
          pTooltip="Exportar Formato" class="btnCabecera"></p-button>
        </div>
        <div class="cabeceraPickList">
          <span style="font-weight: bold;">Clientes Actuales</span>
          <input type="file" (change)="onFileChange($event)" id="fileInput" #fileInput style="display: none" />
          <p-button icon="pi pi-file-import" (onClick)="ImportClient()" pTooltip="Importar Clientes"
          class="btnCabecera"></p-button>
        </div>
      </div>
      <div class="a-w1-row" style="padding-top: 20px;">
        <p-pickList [source]="ListaTemp" [target]="ListaCliEjeActivos" [responsive]="true"
          targetHeader="Clientes Actuales" [showTargetControls]="false" [dragdrop]="true" [responsive]="true"
          sourceHeader="Clientes Disponibles" [showSourceControls]="false" (onMoveToTarget)="AgregarItem($event)"
          [sourceStyle]="{ height: '21rem' }" [targetStyle]="{ height: '21rem' }" scrollHeight="21rem"
          (onMoveToSource)="EliminarItem($event)" filterBy="entC_NomPadre" sourceFilterPlaceholder="Buscar por nombre"
          targetFilterPlaceholder="Buscar por nombre" breakpoint="1400px" class="w-full"
          (onMoveAllToSource)="EliminarItem($event)" (onMoveAllToTarget)="AgregarItem($event)">
          <!-- <ng-template pTemplate="sourceHeader" styleClass="p-0 h-3rem text-base">
            
          </ng-template>
          <ng-template pTemplate="targetHeader" styleClass="p-0 h-3rem text-base">
            
          </ng-template> -->
          <ng-template let-option let-selected="selected" pTemplate="option">
            <div class="flex-1 flex flex-col">
              <!-- <p-skeleton width="100%" styleClass="mb-2" *ngIf="carga"/> -->
              <span class="text-xs font-light">{{ option.entC_NomPadre }}</span>
            </div>
          </ng-template>
        </p-pickList>
      </div>
    </form>
  </div>
</p-dialog>